import { useState, useEffect, useCallback } from 'react';
import styles from './ImageLightbox.module.css';

export default function VideoLightbox({ videos, currentIndex, onClose }) {
  const [index, setIndex] = useState(currentIndex || 0);

  const goNext = useCallback(() => setIndex(i => (i + 1) % videos.length), [videos.length]);
  const goPrev = useCallback(() => setIndex(i => (i - 1 + videos.length) % videos.length), [videos.length]);

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    }
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose, goNext, goPrev]);

  const clip = videos[index];

  return (
    <div className={styles.overlay} onClick={onClose}>
      {/* Close */}
      <button className={styles.close} onClick={onClose}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      {/* Prev */}
      {videos.length > 1 && (
        <button className={styles.arrow + ' ' + styles.arrowLeft} onClick={e => { e.stopPropagation(); goPrev(); }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
      )}

      {/* Video — key forces a fresh element (and autoplay) when navigating */}
      <video
        key={clip.videoUrl}
        src={clip.videoUrl}
        poster={clip.posterUrl}
        controls
        autoPlay
        playsInline
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: '85vw',
          maxHeight: '80vh',
          objectFit: 'contain',
          borderRadius: 'var(--rlg)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          background: '#000',
        }}
      />

      {/* Next */}
      {videos.length > 1 && (
        <button className={styles.arrow + ' ' + styles.arrowRight} onClick={e => { e.stopPropagation(); goNext(); }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      )}

      {/* Counter + timestamp */}
      <div className={styles.counter}>
        {clip.date}{clip.timestamp ? ` · ${clip.timestamp}` : ''}{videos.length > 1 ? `  —  ${index + 1} / ${videos.length}` : ''}
      </div>
    </div>
  );
}
